import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import dayjs from 'dayjs';

const DUE_WARNING_WINDOW_DAYS = 3;

export const getDisclosureDueChip = (earliestClosingDate, now = dayjs()) => {
  if (!earliestClosingDate) {
    return null;
  }

  const dueDate = dayjs(earliestClosingDate);

  if (!dueDate.isValid()) {
    return null;
  }

  const daysUntilDue = dueDate.startOf('day').diff(now.startOf('day'), 'day');

  if (daysUntilDue < 0) {
    return { label: 'LE overdue', variant: LabelVariant.RED };
  }

  if (daysUntilDue === 0) {
    return { label: 'LE due today', variant: LabelVariant.ORANGE };
  }

  if (daysUntilDue <= DUE_WARNING_WINDOW_DAYS) {
    return {
      label: `LE due in ${daysUntilDue} ${daysUntilDue === 1 ? 'day' : 'days'}`,
      variant: LabelVariant.ORANGE,
    };
  }

  return null;
};
